export default function ($http) {
    return function (pageNumber, filterCriteria) {
        return $http({
            method: 'GET',
            url: 'api/dealers/list',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {
                pageNumber,
                filter: filterCriteria
            }
        })
        .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/list/getDealersList.js